import { render, staticRenderFns } from "./ModalPropostasExcluidas.vue?vue&type=template&id=68e3eb8f&scoped=true"
import script from "./ModalPropostasExcluidas.vue?vue&type=script&lang=js"
export * from "./ModalPropostasExcluidas.vue?vue&type=script&lang=js"
import style0 from "./ModalPropostasExcluidas.vue?vue&type=style&index=0&id=68e3eb8f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3eb8f",
  null
  
)

export default component.exports